const CATALOG_SEARCH_HISTORY_KEY = "storefront.catalogSearchHistory"
export const CATALOG_SEARCH_HISTORY_LIMIT = 5

type BrowserStorage = Pick<Storage, "getItem" | "setItem">

const getStorage = (): BrowserStorage | null => {
  if (typeof window === "undefined") return null

  try {
    return window.localStorage
  } catch {
    return null
  }
}

const normalizeQuery = (query: string) => query.trim()

const getQueryKey = (query: string) => query.toLocaleLowerCase("ru-RU")

const isQueryList = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === "string")

export const catalogSearchHistory = {
  getAll(): string[] {
    const storage = getStorage()
    if (!storage) return []

    try {
      const raw = storage.getItem(CATALOG_SEARCH_HISTORY_KEY)
      if (!raw) return []

      const parsed: unknown = JSON.parse(raw)
      if (!isQueryList(parsed)) return []

      return parsed
        .map(normalizeQuery)
        .filter(Boolean)
        .reduce<string[]>((queries, query) => {
          if (queries.some((item) => getQueryKey(item) === getQueryKey(query))) return queries
          return [...queries, query]
        }, [])
        .slice(0, CATALOG_SEARCH_HISTORY_LIMIT)
    } catch {
      return []
    }
  },

  save(query: string): string[] {
    const normalizedQuery = normalizeQuery(query)
    const current = this.getAll()
    if (!normalizedQuery) return current

    const next = [
      normalizedQuery,
      ...current.filter((item) => getQueryKey(item) !== getQueryKey(normalizedQuery)),
    ].slice(0, CATALOG_SEARCH_HISTORY_LIMIT)
    const storage = getStorage()

    if (!storage) return next

    try {
      storage.setItem(CATALOG_SEARCH_HISTORY_KEY, JSON.stringify(next))
    } catch {
      // History is optional; navigation must continue when browser storage is unavailable.
    }

    return next
  },
}
